import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { Concessionaria } from '../_model/concessionaria';
import { EmpresaService } from '../_service/empresa.service';

@Injectable({ providedIn: 'root' })
export class ConcessionariaResolver implements Resolve<Observable<Concessionaria[]>> {

  constructor(private service: EmpresaService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<Concessionaria[]> {
    return this.service.getConcessionarias(
        'mercedesBenz',
        'veiculosComerciais',
        '',
        '',
    );
  }
}
